import { isEmpty } from 'lodash'
import { PHOTO_TYPE, QUESTION_TYPE } from 'types'
import findImagesOfType from './findImagesOfType'

// Builds the Formik initial values for a list of custom questions. Photos are uploaded as
// soon as they are picked, so a question's photos are seeded from the trip's images to
// keep already-uploaded photos visible when the form is re-mounted.
export default function loadQuestionFormValues(trip, questions) {
  if (isEmpty(questions)) return {}
  const currentTripImages = trip?.currentTripImages || []

  return questions.reduce((initialValues, question) => {
    const { fieldName, questionId, type } = question
    let value = ''
    if (type === QUESTION_TYPE.PHOTO) {
      const { photoType } = question
      value =
        photoType === PHOTO_TYPE.CUSTOM
          ? findCustomImagesForQuestion(currentTripImages, questionId)
          : findImagesOfType(currentTripImages, photoType)
    }
    initialValues[fieldName] = value
    return initialValues
  }, {})
}

function findCustomImagesForQuestion(images, customQuestionId) {
  return images
    .filter(({ questionId }) => questionId === customQuestionId)
    .map(({ filename, id, url }) => ({
      id,
      name: filename,
      type: 'image/*',
      url,
    }))
}
